/* eslint-disable */
import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";

export default function Changelog() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/public/changelog")
      .then(({ data }) => setEntries(data.entries || []))
      .finally(() => setLoading(false));
  }, []);
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-12" data-testid="changelog-page">
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-[var(--rg-sage)] mb-3">Public Changelog</div>
        <h1 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl text-[var(--rg-text-strong)] mb-8">
          What&apos;s new in Regulens
        </h1>
        {loading ? (
          <div className="text-[var(--rg-text)]">Loading…</div>
        ) : entries.length === 0 ? (
          <div className="rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)] p-6 text-sm text-[var(--rg-text)]" data-testid="changelog-empty">
            No changelog entries yet. Check back soon.
          </div>
        ) : (
          <ol className="space-y-3">
            {entries.map((e) => (
              <li key={e.id} className="rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)] p-4" data-testid={`changelog-entry-${e.id}`}>
                <div className="text-xs font-mono text-[var(--rg-sage)] mb-1">{e.entry_date}</div>
                <div className="text-sm text-[var(--rg-text)] leading-relaxed">{e.description}</div>
              </li>
            ))}
          </ol>
        )}
      </section>
    </Layout>
  );
}
